import React from 'react';
import { Button, Icon, Link, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { events } from 'pages/settings/secondary/moving/state-machine';
import { Container } from 'styles';
import { StyledContainer } from './set-up-service.style';

const getCopy = copyFor('settings.moving.setUpService');

interface Props {
  context: MovingStateMachineContext;
  next: (...args: any[]) => any;
  send: (event: string) => void;
}

export const SetUpService = ({ next, context, send }: Props) => {
  const { displayName: utilityName, url } = context.utility;
  const paragraphs: string[] = getCopy('paragraphs', { utilityName });
  return (
    <StyledContainer>
      <Text textStyle="heading800" tag="h1">
        {getCopy('title')}
      </Text>
      {paragraphs.map(paragraph => (
        <Text key={paragraph} margin={{ top: '16px' }}>
          {paragraph}
        </Text>
      ))}
      <Container alignSelf="flex-start" margin={{ top: '32px' }}>
        <Link hideIcon={true} href={url} type="standalone">
          <Icon icon="ExternalLink" margin={{ right: '8px' }} />
          {getCopy('utilityLinkText', { utilityName })}
        </Link>
      </Container>
      <Container
        flex
        grow={1}
        direction="column"
        alignItems="center"
        width="100%"
        margin={{ top: '96px' }}
        small={{ justifyContent: 'flex-end', margin: { top: 0 } }}
      >
        <Button
          fullWidth={true}
          backgroundless
          onClick={() => next()}
          margin={{ bottom: '16px', top: '24px' }}
        >
          {getCopy('remindMeLater')}
        </Button>
        <Button
          backgroundless={true}
          fullWidth={true}
          onClick={() => send(events.hasSetUpService)}
        >
          {getCopy('postSetupText')}
        </Button>
      </Container>
    </StyledContainer>
  );
};
